const getCartItemProductId = (item = {}) =>
  String(item.productId || item.product_id || "").trim();

const getCartItemName = (item = {}) =>
  String(item.name || item.product_name || item.title || "Item").trim();

const getCartItemQuantity = (item = {}) => Math.max(1, Number(item.quantity) || 1);

export const collectCartInventoryIssues = (cartItems = [], inventoryProducts = []) => {
  const inventoryById = new Map(
    (inventoryProducts || [])
      .filter((product) => product?.id)
      .map((product) => [String(product.id).trim(), product])
  );

  const issues = [];

  for (const item of cartItems || []) {
    const productId = getCartItemProductId(item);
    const product = inventoryById.get(productId);
    const requestedQuantity = getCartItemQuantity(item);

    if (!product) {
      issues.push({
        productId,
        productName: getCartItemName(item),
        requestedQuantity,
        availableQuantity: 0,
        message: `${getCartItemName(item)} is no longer available.`,
      });
      continue;
    }

    const productName = getCartItemName(product) || getCartItemName(item);
    const availableQuantity = Math.max(0, Number(product.stock) || 0);

    if (!product.is_active) {
      issues.push({
        productId,
        productName,
        requestedQuantity,
        availableQuantity,
        message: `${productName} is currently unavailable.`,
      });
      continue;
    }

    if (availableQuantity < requestedQuantity) {
      issues.push({
        productId,
        productName,
        requestedQuantity,
        availableQuantity,
        message: `Only ${availableQuantity} left for ${productName}. Please reduce the quantity.`,
      });
    }
  }

  return issues;
};

